var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLendorDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_8515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 16.25V6C1.75 5.30921 2.30921 4.75 3 4.75H16.25V8V8.75V9.5V12V12.75H17H21.465H22.25V16.25H21H20.25V17C20.25 15.7558 19.2442 14.75 18 14.75C16.7558 14.75 15.75 15.7558 15.75 17V16.25H15H9H8.25V17C8.25 15.7558 7.24421 14.75 6 14.75C4.75579 14.75 3.75 15.7558 3.75 17V16.25H3H1.75Z",
    fill: "#419485",
    stroke: "#419485",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_8515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendorDashboardIcon);
export default __webpack_public_path__ + "static/media/lendor_dashboard_icon.f528e5edb3b678e134c9f508f89d9070.svg";
export { ForwardRef as ReactComponent };